export const OPEN_CATALOG_COURSE_FLOW_QUERY_PARAM = 'occflow'
export const OPEN_CATALOG_COURSE_PARAM = 'objectiveId'
export const SELF_REGISTERED_QUERY_PARAM = 'selfRegistered' // this param is set by platform-frontend self register flow

export const enum OPEN_CATALOG_COURSE_FLOW {
  ADD_TO_MY_COURSES = 'addToMyCourses', // stays in courses list
  START_THE_COURSE = 'startTheCourse', // redirects to course content
}

export const getOpenCatalogFlowParam = () => {
  const query = new URLSearchParams(window.location.search)
  return query.get(OPEN_CATALOG_COURSE_FLOW_QUERY_PARAM) as OPEN_CATALOG_COURSE_FLOW
}

export const getOpenCatalogObjectiveIdParam = () => {
  const query = new URLSearchParams(window.location.search)
  return query.get(OPEN_CATALOG_COURSE_PARAM) as string
}

export const getSelfRegisteredQueryParam = () => {
  const query = new URLSearchParams(window.location.search)
  return Boolean(query.has(SELF_REGISTERED_QUERY_PARAM))
}
